function landing(){

   var landing = document.querySelector('.landing-wrap');


    const draggableElement = document.querySelector(".on-sale");
    const draggable = document.querySelectorAll(".draggable");
    if(draggableElement){
        makeDraggable(draggableElement);
    }

    // for (let a = 0; a < draggable.length; a++) {
    //     const element = draggable[a];
    //     makeDraggable(element);
    // }

    if(landing){

        document.body.classList.add('landing');

        var groups = landing.querySelectorAll('.load-in');
        var runTime = 0;

        var defaultTime = [0];
        var shortTime = [1, 4, 6, 8,10, 11];

        for (let a = 0; a < groups.length; a++) {

            const randomTimeFlux = Math.floor(Math.random() * 100) + 50;

            if(defaultTime.includes(a)){
                runTime += randomTimeFlux + 100;
            }else if(shortTime.includes(a)){
                runTime += randomTimeFlux + 80;
            }else{
                runTime += randomTimeFlux + 300;
            }
            
            const elm = groups[a];   


            show(elm, runTime);
        }

        setTimeout(function(){
            if(document.querySelector('.on-sale')){
                var rand = Math.floor(Math.random() * 5) + 10;
                document.querySelector('.on-sale').style.transform = `rotate(-13deg) scale(1)`;
            }
        }, groups.length * 300);



        const scroller = document.querySelector('.loop-scroller');
        const dataString = document.querySelector('.img-data').dataset.srcs;
        console.log(dataString);
        var data = dataString.split(',');

        const splitIndex = Math.floor(Math.random() * data.length);

        const firstPart = data.slice(0, splitIndex);
        const secondPart = data.slice(splitIndex);

        data = secondPart.concat(firstPart);
        const loopImgs = scroller.querySelectorAll('img');

        let speed = 50;
        let count = 0;


        function moveIt() { 

            let firstItem =  data.shift()
            data.push(firstItem);

            for (let a = 0; a < loopImgs.length; a++) {
                const element = loopImgs[a];
                element.src = data[a];
            }

            count++;
        
            speed = speed+count;
           
            if(count < 18){
                setTimeout(moveIt, speed);
            }
            
        }

        moveIt()

    }else{
        document.body.classList.remove('landing');
    }

    function show(elm, i){

        const randomTimeFlux = Math.floor(Math.random() * 30) + 30;
       
        setTimeout(function(){

            if(elm.id == 'short'){

                setTimeout(function(){
                let eye = document.querySelectorAll('#eye');

                for (let a = 0; a < eye.length; a++) {
                    eye[a].style.opacity = 1;
                }

                for (let a = 0; a <  window.animations.length; a++) {
                    const animation = window.animations[a];
                    animation.setSpeed(Math.floor(Math.random() * 5) + 2);
                    animation.goToAndStop(13,true);
                    animation.play();
                }

                }, 100);

               
    
            }

            elm.style.opacity = 1;
            
            
        }, i);
    }

}

function makeDraggable(element) {
    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;

    let velocityX = 0,
        velocityY = 0;
    
    let isDragging = false;

    element.addEventListener("mousedown", dragMouseDown);
    element.addEventListener("touchstart", dragMouseDown);

    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();

        isDragging = true;

        pos3 = e.clientX || e.touches[0].clientX;
        pos4 = e.clientY || e.touches[0].clientY;
        document.onmouseup = closeDragElement;
        document.ontouchend = closeDragElement;
        document.onmousemove = elementDrag;
        document.ontouchmove = elementDrag;
    }

    function elementDrag(e) {
        if (!isDragging) return;

        element.classList.add('dragging');

        e = e || window.event;
        e.preventDefault();

        let clientX = e.clientX || e.touches[0].clientX;
        let clientY = e.clientY || e.touches[0].clientY;

        velocityX = clientX - pos3;
        velocityY = clientY - pos4;

        pos3 = clientX;
        pos4 = clientY;

        let newPosX = element.offsetLeft + velocityX;
        let newPosY = element.offsetTop + velocityY;

        if (
            newPosX >= 0 &&
            newPosY >= 0 &&
            newPosX + element.offsetWidth <= window.innerWidth &&
            newPosY + element.offsetHeight <= window.innerHeight
        ) {
            element.style.top = newPosY + "px";
            element.style.left = newPosX + "px";
        }
    }

    function closeDragElement() {
        isDragging = false;
        document.onmouseup = null;
        document.ontouchend = null;
        document.onmousemove = null;
        document.ontouchmove = null;


        // Add inertia for throwing the element around
        if (velocityX !== 0 || velocityY !== 0) {
            let animationId = requestAnimationFrame(inertiaAnimation);

            function inertiaAnimation() {
                velocityX *= 0.95;
                velocityY *= 0.95;

                let newPosX = element.offsetLeft + velocityX;
                let newPosY = element.offsetTop + velocityY;

                if (
                    newPosX >= 0 &&
                    newPosY >= 0 &&
                    newPosX + element.offsetWidth <= window.innerWidth &&
                    newPosY + element.offsetHeight <= window.innerHeight &&
                    (Math.abs(velocityX) > 0.1 || Math.abs(velocityY) > 0.1)
                ) {
                    element.style.top = newPosY + "px";
                    element.style.left = newPosX + "px";
                    animationId = requestAnimationFrame(inertiaAnimation);
                }
            }
        }
    }
}



export default landing;